export default __webpack_public_path__ + "static/media/dozulemini.3d5b5ac2.jpg";